import CoreConfig from '../../core/config'

var Settings = null;
try {
    Settings = require('./../../projectSettings');
    Settings = Settings.Settings();
} catch (e) {
    Settings = null;
}

export default {
    'version': '1.0.1',
    'authorization': (Settings && Settings.front.authorization !== null && typeof (Settings.front.authorization) !== "undefined") ? Settings.front.authorization : true,
    'name': CoreConfig.name,
    'api': CoreConfig.api,
    'language': CoreConfig.language,
    'prefix': CoreConfig.prefix,
    'adminURL': CoreConfig.adminURL,
    'frontURL': CoreConfig.frontURL,
    'client': CoreConfig.client,
    'renderer': CoreConfig.renderer,
    'initialRoute': CoreConfig.initialRoute,
    destroy: CoreConfig.destroy,
    set: CoreConfig.set,
    get: CoreConfig.get,
    clearStorage() {
        this.destroy('apitoken');
        this.destroy('user');
        this.destroy('ssoId');
        this.destroy('userName');
    },
    setToken: CoreConfig.setToken,
    getToken: CoreConfig.getToken,
    setUser: CoreConfig.setUser,
    getUser: CoreConfig.getUser,
    getApiConfig: CoreConfig.getApiConfig,
    getId: CoreConfig.getId,
    getStoragePrefixes: CoreConfig.getStoragePrefixes,
    generateId: CoreConfig.generateId,
    getSsoLink: CoreConfig.getSsoLink,
    getSsoId: CoreConfig.getSsoId,
    setSsoId: CoreConfig.setSsoId,
    settings: Settings,
    getCookie: CoreConfig.getCookie,
    getCurrentCsodSessionGuid: CoreConfig.getCurrentCsodSessionGuid,
};



// WEBPACK FOOTER //
// ./src/frontend/config/index.js